import logo from './logo.svg';
import './App.css';
import Map from "./Map"

function App() {
  return (
    <>
    <div className='map-custom-box'>
    <Map />
    </div>
 
    </>
  );
}

export default App;
